import { SERVICES, GALLERY, HERO_IMG } from "./constants";

const img = (id) => SERVICES.find((s) => s.id === id)?.image;
const gallery = (label) => GALLERY.find((g) => g.label === label)?.url || GALLERY.find((g) => g.label === label)?.after;

const NAPLES_AREAS = ["Naples", "North Naples", "East Naples", "Golden Gate", "Marco Island", "Bonita Springs"];

export const CLOSING_CTA = {
  en: { before: "Get your free estimate today — Call or text ", mid: " or ", link: "request an estimate online", after: ". Hablamos español." },
  es: { before: "Pide tu presupuesto gratis hoy — Llama o escribe al ", mid: " o ", link: "pide tu presupuesto en línea", after: "." },
};

export const PAGE_UI = {
  en: {
    home: "Home",
    services: "Services",
    areas: "Areas",
    servicesPath: "/services",
    areasPath: "/#areas",
    estimatePath: "/estimate",
    midCta: "Get your free, no-obligation quote today",
    midCtaBtn: "Free 60-Second Estimate",
    faqTitle: "Frequently Asked Questions",
    faqSubtitle: "Answers to the questions Naples homeowners ask us most.",
    recentWork: "Recent Post-Construction Work",
    ctaTitle: "Ready for a Spotless Space?",
    ctaText: "Get your free estimate today — Call or text (239) 244-1934 or request an estimate online. Hablamos español.",
    ctaBtn: "Get a Free Estimate",
    callBtn: "Call",
  },
  es: {
    home: "Inicio",
    services: "Servicios",
    areas: "Zonas",
    servicesPath: "/es#servicios",
    areasPath: "/es#zonas",
    estimatePath: "/es/estimate",
    midCta: "Pide hoy tu presupuesto gratis y sin compromiso",
    midCtaBtn: "Presupuesto en 60 segundos",
    faqTitle: "Preguntas Frecuentes",
    faqSubtitle: "Respuestas a lo que más nos preguntan en Naples.",
    recentWork: "Trabajos recientes",
    ctaTitle: "¿Listo para un espacio impecable?",
    ctaText: "Pide tu presupuesto gratis hoy — Llama o escribe al (239) 244-1934 o pide tu presupuesto en línea.",
    ctaBtn: "Pedir presupuesto gratis",
    callBtn: "Llamar",
  },
};

export const AREA_PAGES = [
  {
    slug: "north-naples",
    keyword: "House Cleaning North Naples FL",
    title: "House Cleaning & Housekeeping in North Naples, FL | Cindyrella",
    metaDescription:
      "Trusted house cleaning and housekeeping in North Naples, FL — homes, condos and vacation rentals. Licensed & insured. Free estimate (239) 244-1934.",
    h1: "House Cleaning & Housekeeping in North Naples, FL",
    breadcrumbName: "North Naples",
    serviceType: "House cleaning and housekeeping",
    areaServed: ["North Naples", "Naples"],
    image: HERO_IMG,
    imageAlt: "Clean, bright kitchen in a North Naples home cared for by Cindyrella Cleaning",
    intro: [
      "Cindyrella Cleaning provides house cleaning, housekeeping and deep cleaning for homes and condos throughout North Naples.",
      "Many North Naples homes are seasonal. We offer seasonal home care: regular visits while you're away and a full deep clean before you return, so your home is ready the day you arrive.",
    ],
    sections: [
      {
        h2: "Services in North Naples",
        list: [
          "Housekeeping — weekly, bi-weekly or monthly",
          "House cleaning",
          "Deep cleaning",
          "Move in / move out",
          "Vacation rental cleaning",
          "Office cleaning",
        ],
      },
    ],
    closingCta: true,
    faqs: [],
  },
  {
    slug: "marco-island",
    keyword: "Cleaning Services Marco Island FL",
    title: "Cleaning Services in Marco Island, FL | Cindyrella Cleaning",
    metaDescription:
      "House cleaning, housekeeping and vacation rental cleaning on Marco Island, FL. Licensed & insured, photo report after every clean. (239) 244-1934.",
    h1: "Cleaning & Housekeeping Services on Marco Island, FL",
    breadcrumbName: "Marco Island",
    serviceType: "House cleaning, housekeeping and vacation rental cleaning",
    areaServed: ["Marco Island"],
    image: gallery("Outdoor Lanai & Lighting Care"),
    imageAlt: "Lanai and outdoor living area cleaned by Cindyrella Cleaning in Southwest Florida",
    intro: [
      "From beachfront condos to canal-front homes, Cindyrella Cleaning keeps Marco Island properties clean, fresh and guest-ready.",
      "Salt air, sand and humidity mean island homes need extra attention: we pay special attention to sliding-door tracks, lanais, glass and floors where sand builds up.",
    ],
    sections: [
      {
        h2: "Popular services on Marco Island",
        list: [
          "Vacation rental turnovers for Airbnb and VRBO hosts",
          "Condo cleaning for high-rise and mid-rise buildings",
          "Housekeeping and seasonal home care",
          "Deep cleaning before and after season",
        ],
      },
    ],
    closingCta: true,
    faqs: [],
  },
  {
    slug: "bonita-springs",
    keyword: "House Cleaning Bonita Springs FL",
    title: "House Cleaning & Housekeeping in Bonita Springs, FL | Cindyrella",
    metaDescription:
      "Reliable house cleaning and housekeeping in Bonita Springs, FL for homes, condos and rentals. Licensed & insured. Free estimate: (239) 244-1934.",
    h1: "House Cleaning & Housekeeping in Bonita Springs, FL",
    breadcrumbName: "Bonita Springs",
    serviceType: "House cleaning and housekeeping",
    areaServed: ["Bonita Springs"],
    image: gallery("Naples Luxury Kitchen"),
    imageAlt: "Spotless kitchen after a professional house cleaning by Cindyrella Cleaning",
    intro: [
      "Cindyrella Cleaning serves homeowners, renters and businesses in Bonita Springs.",
      "Whether you need a weekly housekeeper, a one-time deep clean before guests arrive, or a move-out clean, our licensed and insured team gets it done and sends you a photo report when we finish.",
    ],
    sections: [
      {
        h2: "Services in Bonita Springs",
        list: [
          "Housekeeping",
          "House cleaning",
          "Deep cleaning",
          "Move in / move out cleaning",
          "Vacation rental cleaning",
          "Commercial cleaning",
        ],
      },
    ],
    closingCta: true,
    faqs: [],
  },
  {
    slug: "golden-gate-east-naples",
    keyword: "House Cleaning Golden Gate East Naples FL",
    title: "House Cleaning in Golden Gate & East Naples, FL | Cindyrella",
    metaDescription:
      "Affordable, professional house cleaning and housekeeping in Golden Gate and East Naples, FL. Bilingual team, licensed & insured. (239) 244-1934.",
    h1: "House Cleaning in Golden Gate & East Naples, FL",
    breadcrumbName: "Golden Gate & East Naples",
    serviceType: "House cleaning and housekeeping",
    areaServed: ["Golden Gate", "Golden Gate Estates", "East Naples"],
    image: img("residential"),
    imageAlt: "Clean living room in a family home — house cleaning by Cindyrella Cleaning",
    intro: [
      "Cindyrella Cleaning is proud to serve families in Golden Gate, Golden Gate Estates and East Naples with dependable house cleaning and housekeeping.",
      "We're a bilingual team — we speak English and Spanish — so communication is always easy.",
    ],
    sections: [
      {
        h2: "Services",
        list: ["Weekly and bi-weekly housekeeping", "One-time deep cleaning", "Move in / move out cleaning", "Office and restaurant cleaning"],
      },
    ],
    closingCta: true,
    faqs: [],
  },
];

export const SERVICE_PAGES_ES = [
  {
    slug: "limpieza-de-casas-naples-fl",
    enPath: "/services/housekeeping-naples-fl",
    keyword: "Limpieza de casas Naples FL",
    title: "Limpieza de Casas y Housekeeping en Naples, FL | Cindyrella",
    metaDescription:
      "Servicio de limpieza de casas y housekeeping semanal o quincenal en Naples, FL. Con licencia y seguro, reporte con fotos. Llama al (239) 244-1934.",
    h1: "Limpieza de Casas y Housekeeping en Naples, FL",
    breadcrumbName: "Limpieza de casas",
    serviceType: "Housekeeping",
    areaServed: NAPLES_AREAS,
    image: img("residential"),
    imageAlt: "Sala limpia y ordenada después del servicio de housekeeping de Cindyrella Cleaning en Naples, FL",
    intro: [
      "Llegar a una casa limpia y ordenada no debería costarte todo el fin de semana. En Cindyrella Cleaning ofrecemos limpieza de casas y housekeeping en Naples, FL para familias, personas mayores y residentes de temporada.",
    ],
    sections: [
      {
        h2: "En cada visita",
        list: [
          "Limpieza de polvo en muebles, zócalos y ventiladores",
          "Cocina: encimeras, fregadero, estufa y electrodomésticos por fuera",
          "Baños desinfectados",
          "Aspirado y trapeado de pisos",
          "Camas tendidas",
          "Basura y orden general",
        ],
      },
      {
        h2: "Planes de housekeeping",
        list: ["Semanal", "Quincenal", "Mensual", "Cuidado de casa de temporada — mientras estás fuera de Florida"],
      },
      {
        h2: "¿Por qué Cindyrella?",
        list: [
          "Con licencia y seguro",
          "Reporte con fotos después de cada limpieza",
          "El mismo equipo siempre que sea posible",
          "Atención en español e inglés",
        ],
      },
      {
        h2: "Zonas que atendemos",
        paras: ["Naples, North Naples, East Naples, Golden Gate, Marco Island y Bonita Springs."],
      },
    ],
    closingCta: true,
    faqs: [
      {
        q: "¿Cuál es la diferencia entre housekeeping y limpieza de casa?",
        a: "La limpieza de casa suele ser limpiar superficies, pisos y baños. El housekeeping es el cuidado continuo y recurrente de tu hogar: la misma limpieza, más orden general y camas tendidas, en un horario fijo.",
      },
      {
        q: "¿Tengo que estar en casa durante la visita?",
        a: "No. Muchos clientes nos dejan una llave o el código de la puerta. Al terminar te enviamos un reporte con fotos.",
      },
      {
        q: "¿Traen sus propios productos?",
        a: "Sí, llevamos todos los productos y equipos. Si prefieres un producto específico, solo dínoslo.",
      },
    ],
  },
  {
    slug: "limpieza-profunda-naples-fl",
    enPath: "/services/deep-cleaning-naples-fl",
    keyword: "Limpieza profunda Naples FL",
    title: "Limpieza Profunda en Naples, FL | Cindyrella Cleaning",
    metaDescription:
      "Limpieza profunda de casas en Naples, FL: zócalos, gabinetes, juntas del baño, dentro del microondas y más. Con licencia y seguro. (239) 244-1934.",
    h1: "Limpieza Profunda en Naples, FL",
    breadcrumbName: "Limpieza profunda",
    serviceType: "Limpieza profunda",
    areaServed: ["Naples", "Collier County"],
    image: gallery("Kitchen Deep Clean"),
    imageAlt: "Cocina después de una limpieza profunda realizada por Cindyrella Cleaning en Naples, FL",
    intro: [
      "Una limpieza profunda llega a donde la limpieza normal no llega. Es ideal antes o después de la temporada, antes de recibir visitas o para empezar un plan recurrente.",
    ],
    sections: [
      {
        h2: "Todo lo de una limpieza normal, más",
        list: [
          "Zócalos y marcos de puertas limpiados a mano",
          "Dentro del microondas (y por dentro del horno y la nevera, si lo solicitas)",
          "Frentes de gabinetes",
          "Juntas y azulejos del baño, y sarro",
          "Rieles de ventanas",
          "Rejillas y persianas",
          "Debajo de muebles movibles",
        ],
      },
    ],
    closingCta: true,
    faqs: [],
  },
  {
    slug: "limpieza-de-mudanza-naples-fl",
    enPath: "/services/move-in-move-out-cleaning-naples-fl",
    keyword: "Limpieza de mudanza Naples FL",
    title: "Limpieza de Mudanza en Naples, FL | Cindyrella Cleaning",
    metaDescription:
      "Limpieza de entrada y salida de casas y apartamentos en Naples, FL para dueños, inquilinos, realtors y administradores. Llama al (239) 244-1934.",
    h1: "Limpieza de Mudanza en Naples, FL",
    breadcrumbName: "Limpieza de mudanza",
    serviceType: "Limpieza de mudanza (entrada y salida)",
    areaServed: ["Naples", "Collier County"],
    image: gallery("Naples Luxury Kitchen"),
    imageAlt: "Cocina vacía e impecable tras una limpieza de mudanza de Cindyrella Cleaning",
    intro: [
      "Trabajamos con dueños, inquilinos que quieren recuperar su depósito, y realtors y administradores de propiedades (enviamos reporte con fotos).",
    ],
    sections: [
      {
        h2: "Qué incluye",
        list: [
          "Dentro de gabinetes, cajones y clósets",
          "Dentro de electrodomésticos",
          "Baños a fondo",
          "Zócalos, puertas y enchufes",
          "Pisos y rieles de ventanas",
        ],
      },
    ],
    closingCta: true,
    faqs: [],
  },
  {
    slug: "limpieza-airbnb-naples-fl",
    enPath: "/services/airbnb-cleaning-naples-fl",
    keyword: "Limpieza de Airbnb Naples FL",
    title: "Limpieza de Airbnb y Alquiler Vacacional en Naples | Cindyrella",
    metaDescription:
      "Limpieza de cambio de huéspedes para Airbnb y VRBO en Naples, Marco Island y Bonita Springs. Reporte con fotos en cada limpieza. (239) 244-1934.",
    h1: "Limpieza de Airbnb y Alquiler Vacacional en Naples, FL",
    breadcrumbName: "Limpieza de Airbnb",
    serviceType: "Limpieza de Airbnb y alquiler vacacional",
    areaServed: ["Naples", "Marco Island", "Bonita Springs"],
    image: gallery("Airbnb Ready"),
    imageAlt: "Dormitorio de alquiler vacacional listo para huéspedes, preparado por Cindyrella Cleaning",
    intro: [
      "Desde hace más de 6 años limpiamos Airbnb, VRBO y casas de renta en Naples, Marco Island y Bonita Springs. Hemos atendido a más de 50 propietarios, desde los que después vendieron su casa hasta los que siguen con nosotros hoy.",
    ],
    sections: [
      {
        h2: "Cada cambio de huésped incluye",
        list: [
          "Limpieza completa",
          "Lavandería incluida: lavamos, secamos y doblamos sábanas y toallas",
          "Camas tendidas con ropa limpia",
          "Amenidades repuestas con los insumos del dueño",
          "Basura y platos, y revisión de electrodomésticos",
          "Reporte con fotos",
        ],
        outro: [
          "Avisamos de inmediato si hay daños o faltantes. También te ayudamos a dejar la propiedad lista si decides venderla.",
        ],
      },
    ],
    closingCta: true,
    faqs: [
      {
        q: "¿Hacen la lavandería?",
        a: "Sí. Lavar, secar y doblar sábanas y toallas es parte de nuestro servicio de alquiler vacacional.",
      },
      {
        q: "¿Cuánto tiempo llevan limpiando alquileres vacacionales?",
        a: "Más de 6 años, con más de 50 propietarios atendidos en Naples y alrededores.",
      },
    ],
  },
  {
    slug: "limpieza-comercial-naples-fl",
    enPath: "/services/commercial-cleaning-naples-fl",
    keyword: "Limpieza comercial Naples FL",
    title: "Limpieza de Oficinas y Comercios en Naples, FL | Cindyrella",
    metaDescription:
      "Limpieza comercial para oficinas, restaurantes, consultorios y edificios de gobierno en Naples, FL. Horarios flexibles, con seguro. (239) 244-1934.",
    h1: "Limpieza de Oficinas y Comercios en Naples, FL",
    breadcrumbName: "Limpieza comercial",
    serviceType: "Limpieza de oficinas y comercios",
    areaServed: ["Naples", "Collier County"],
    image: img("offices"),
    imageAlt: "Oficina moderna limpia — servicio de limpieza comercial de Cindyrella Cleaning en Naples, FL",
    intro: [
      "Oficinas, restaurantes (comedor y baños, y cocina si lo solicitas), consultorios médicos y dentales, edificios de gobierno y limpieza post-construcción.",
    ],
    sections: [
      {
        h2: "Cómo trabajamos",
        list: [
          "Servicio fuera de horario o fines de semana",
          "Con licencia y seguro",
          "Reporte con fotos",
          "Un solo contacto para todo",
        ],
        outro: ["Si lo solicitas, te enviamos el certificado de seguro y la revisión de antecedentes del personal."],
      },
    ],
    closingCta: true,
    faqs: [],
  },
];

export const AREA_PAGES_ES = [
  {
    slug: "north-naples",
    enPath: "/areas/north-naples",
    keyword: "Limpieza de casas North Naples FL",
    title: "Limpieza de Casas en North Naples, FL | Cindyrella",
    metaDescription:
      "Limpieza de casas y housekeeping de confianza en North Naples, FL: casas, condominios y alquileres vacacionales. Con licencia y seguro. (239) 244-1934.",
    h1: "Limpieza de Casas y Housekeeping en North Naples, FL",
    breadcrumbName: "North Naples",
    serviceType: "Limpieza de casas y housekeeping",
    areaServed: ["North Naples", "Naples"],
    image: HERO_IMG,
    imageAlt: "Cocina limpia y luminosa en una casa de North Naples atendida por Cindyrella Cleaning",
    intro: [
      "Cindyrella Cleaning ofrece limpieza de casas, housekeeping y limpieza profunda para casas y condominios en todo North Naples.",
      "Muchas casas de North Naples son de temporada. Ofrecemos cuidado de casa de temporada: visitas regulares mientras estás fuera y una limpieza profunda completa antes de tu regreso, para que tu casa esté lista el día que llegas.",
    ],
    sections: [
      {
        h2: "Servicios en North Naples",
        list: [
          "Housekeeping — semanal, quincenal o mensual",
          "Limpieza de casas",
          "Limpieza profunda",
          "Limpieza de mudanza",
          "Limpieza de alquileres vacacionales",
          "Limpieza de oficinas",
        ],
      },
    ],
    closingCta: true,
    faqs: [],
  },
  {
    slug: "marco-island",
    enPath: "/areas/marco-island",
    keyword: "Limpieza Marco Island FL",
    title: "Limpieza de Casas y Airbnb en Marco Island, FL | Cindyrella",
    metaDescription:
      "Limpieza de casas, housekeeping y alquileres vacacionales en Marco Island, FL. Con licencia y seguro, reporte con fotos en cada limpieza. (239) 244-1934.",
    h1: "Limpieza y Housekeeping en Marco Island, FL",
    breadcrumbName: "Marco Island",
    serviceType: "Limpieza de casas, housekeeping y alquileres vacacionales",
    areaServed: ["Marco Island"],
    image: gallery("Outdoor Lanai & Lighting Care"),
    imageAlt: "Lanai y zona exterior limpiados por Cindyrella Cleaning en el suroeste de Florida",
    intro: [
      "Desde condominios frente a la playa hasta casas junto al canal, Cindyrella Cleaning mantiene las propiedades de Marco Island limpias, frescas y listas para huéspedes.",
      "El aire salado, la arena y la humedad hacen que las casas de la isla necesiten atención extra: ponemos especial cuidado en los rieles de las puertas corredizas, los lanais, los cristales y los pisos donde se acumula la arena.",
    ],
    sections: [
      {
        h2: "Servicios más solicitados en Marco Island",
        list: [
          "Cambios de huéspedes para anfitriones de Airbnb y VRBO",
          "Limpieza de condominios en edificios altos y medianos",
          "Housekeeping y cuidado de casa de temporada",
          "Limpieza profunda antes y después de la temporada",
        ],
      },
    ],
    closingCta: true,
    faqs: [],
  },
  {
    slug: "bonita-springs",
    enPath: "/areas/bonita-springs",
    keyword: "Limpieza de casas Bonita Springs FL",
    title: "Limpieza de Casas en Bonita Springs, FL | Cindyrella",
    metaDescription:
      "Limpieza de casas y housekeeping confiable en Bonita Springs, FL para casas, condominios y alquileres. Con licencia y seguro. Presupuesto gratis: (239) 244-1934.",
    h1: "Limpieza de Casas y Housekeeping en Bonita Springs, FL",
    breadcrumbName: "Bonita Springs",
    serviceType: "Limpieza de casas y housekeeping",
    areaServed: ["Bonita Springs"],
    image: gallery("Naples Luxury Kitchen"),
    imageAlt: "Cocina impecable después de una limpieza profesional de Cindyrella Cleaning",
    intro: [
      "Cindyrella Cleaning atiende a propietarios, inquilinos y negocios en Bonita Springs.",
      "Ya sea que necesites una housekeeper semanal, una limpieza profunda antes de que lleguen tus invitados o una limpieza de salida, nuestro equipo con licencia y seguro lo hace y te envía un reporte con fotos al terminar.",
    ],
    sections: [
      {
        h2: "Servicios en Bonita Springs",
        list: [
          "Housekeeping",
          "Limpieza de casas",
          "Limpieza profunda",
          "Limpieza de mudanza",
          "Limpieza de alquileres vacacionales",
          "Limpieza comercial",
        ],
      },
    ],
    closingCta: true,
    faqs: [],
  },
  {
    slug: "golden-gate-east-naples",
    enPath: "/areas/golden-gate-east-naples",
    keyword: "Limpieza de casas Golden Gate East Naples",
    title: "Limpieza de Casas en Golden Gate y East Naples | Cindyrella",
    metaDescription:
      "Limpieza de casas y housekeeping profesional y accesible en Golden Gate y East Naples, FL. Equipo bilingüe, con licencia y seguro. (239) 244-1934.",
    h1: "Limpieza de Casas en Golden Gate y East Naples, FL",
    breadcrumbName: "Golden Gate y East Naples",
    serviceType: "Limpieza de casas y housekeeping",
    areaServed: ["Golden Gate", "Golden Gate Estates", "East Naples"],
    image: img("residential"),
    imageAlt: "Sala limpia en una casa familiar — limpieza de casas por Cindyrella Cleaning",
    intro: [
      "En Cindyrella Cleaning nos enorgullece atender a las familias de Golden Gate, Golden Gate Estates y East Naples con limpieza de casas y housekeeping confiables.",
      "Somos un equipo bilingüe — hablamos español e inglés — así que la comunicación siempre es fácil.",
    ],
    sections: [
      {
        h2: "Servicios",
        list: [
          "Housekeeping semanal y quincenal",
          "Limpieza profunda de una sola vez",
          "Limpieza de mudanza",
          "Limpieza de oficinas y restaurantes",
        ],
      },
    ],
    closingCta: true,
    faqs: [],
  },
];

export const SERVICE_LINKS = {
  en: [
    { label: "Housekeeping", to: "/services/housekeeping-naples-fl" },
    { label: "House Cleaning", to: "/services/house-cleaning-naples-fl" },
    { label: "Deep Cleaning", to: "/services/deep-cleaning-naples-fl" },
    { label: "Move In / Move Out", to: "/services/move-in-move-out-cleaning-naples-fl" },
    { label: "Airbnb & Vacation Rental", to: "/services/airbnb-cleaning-naples-fl" },
    { label: "Office & Commercial", to: "/services/commercial-cleaning-naples-fl" },
  ],
  es: [
    { label: "Limpieza de casas y housekeeping", to: "/es/services/limpieza-de-casas-naples-fl" },
    { label: "Limpieza profunda", to: "/es/services/limpieza-profunda-naples-fl" },
    { label: "Limpieza de mudanza", to: "/es/services/limpieza-de-mudanza-naples-fl" },
    { label: "Limpieza de Airbnb", to: "/es/services/limpieza-airbnb-naples-fl" },
    { label: "Limpieza de oficinas y comercios", to: "/es/services/limpieza-comercial-naples-fl" },
  ],
};

export const AREA_LINKS = {
  en: AREA_PAGES.map((p) => ({ label: p.breadcrumbName, to: `/areas/${p.slug}` })),
  es: AREA_PAGES_ES.map((p) => ({ label: p.breadcrumbName, to: `/es/areas/${p.slug}` })),
};

export const LOCALE_PAIRS = [
  ["/", "/es"],
  ["/estimate", "/es/estimate"],
  ...SERVICE_PAGES_ES.map((p) => [p.enPath, `/es/services/${p.slug}`]),
  ...AREA_PAGES_ES.map((p) => [p.enPath, `/es/areas/${p.slug}`]),
];

export const findAlternate = (pathname) => LOCALE_PAIRS.find(([en, es]) => pathname === en || pathname === es);
